import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export namespace FnsNS {
	export type getContainerRaspiskaRbidosRequest = PayloadAction<{
		id: number | string
		callback?: (res) => unknown
	}>
	export type getContainerResponseRbidosRequest = PayloadAction<{
		id: number | string
	}>
}

export const fnsSlice = createSlice({
	name: 'fns',
	initialState: {},
	reducers: {
		getContainerRaspiskaRbidosRequest: (
			state,
			action: FnsNS.getContainerRaspiskaRbidosRequest
		) => {},
		getContainerResponseRbidosRequest: (
			state,
			action: FnsNS.getContainerResponseRbidosRequest
		) => {},
	},
})
